import React from 'react'
import { Sun, Moon } from 'lucide-react'
import { useTheme } from '../../contexts/ThemeContext'

const ThemeToggle = ({ className = '' }) => {
  const { isDark, toggleTheme, theme } = useTheme()

  const handleToggle = () => {
    toggleTheme()
  }

  return (
    <button
      onClick={handleToggle}
      className={`
        inline-flex items-center justify-center min-h-[44px] min-w-[44px] p-2 rounded-lg transition-colors
        text-slate-500 hover:text-[#cfa190] hover:bg-slate-100
        dark:text-slate-400 dark:hover:text-[#cfa190] dark:hover:bg-slate-800
        ${className}
      `}
      aria-label={isDark ? 'Switch to light mode' : 'Switch to dark mode'}
      title={isDark ? 'Switch to light mode' : 'Switch to dark mode'}
    >
      {isDark ? (
        <Sun size={20} className="transition-transform hover:rotate-45" />
      ) : (
        <Moon size={20} className="transition-transform hover:-rotate-12" />
      )}
    </button>
  )
}

export default ThemeToggle
